export default __webpack_public_path__ + "78829f7ed389353000448f20418b8e6a.png";